// Add your custom JS here.

// core version + navigation, pagination modules:
import Swiper from "swiper/bundle";



document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.tab-content')) {
        // Najdeme div se třídou "swiper-products"
        let swiperProducts = document.querySelector('.tab-content');

        // Najdeme všechny prvky uvnitř swiperProducts, které mají atribut "data-category"
        let items = swiperProducts.querySelectorAll('.swiper-products');

        // Projdeme všechny nalezené prvky a vypíšeme hodnotu atributu "data-category"
        items.forEach(item => {
            let category = item.getAttribute('data-category');
            // alert(category);
            let swipercat = {};

            swipercat[category] = new Swiper('.swiper-products-container[data-category="' + category + '"]', {
                // Optional parameters
                // effect: "coverflow",
                // grabCursor: true,
                // centeredSlides: true,
                slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
                slidesPerView: 1,
                //centeredSlides: true,
                pagination: {
                    el: '.swiper-products-pagination[data-category="' + category + '"]',
                    dynamicBullets: true,
                    // clickable: true, // Kulaté bullety budou klikatelné
                },
                // loop: true,
                speed: 600,
                /*
                        autoplay: {
                            delay: 7000,
                            disableOnInteraction: true,
                            pauseOnMouseEnter: true,
                        },
                */
                a11y: {
                    prevSlideMessage: "Předchozí",
                    nextSlideMessage: "Další",
                },


                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-products-button-next[data-category="' + category + '"]',
                    prevEl: '.swiper-products-button-prev[data-category="' + category + '"]',
                },

                breakpointsInverse: true,
                breakpoints: {
                    20: {
                        slidesPerGroup: 1,   // Kolik snímků bude přeskočeno najednou
                        slidesPerView: 1.15,
                        spaceBetween: 10,

                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        /// slidesPerGroup: 2,   // Kolik snímků bude přeskočeno najednou
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        // slidesPerGroup: 2,   // Kolik snímků bude přeskočeno najednou
                    },
                    1400: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                        //  slidesPerGroup: 3,   // Kolik snímků bude přeskočeno najednou
                    },
                    1520: {
                        slidesPerView: 3,
                        spaceBetween: 100,
                        //  slidesPerGroup: 4,   // Kolik snímků bude přeskočeno najednou
                    },
                },


            });

        });
    }
});

